module.exports = __webpack_public_path__ + "media/images/headshots_married.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/headshots_married.png
// module id = 69
// module chunks = 0